import { useState, useEffect } from 'react'
import TradingRecommendationsList from '@/components/trading/TradingRecommendationsList'
import ActiveHistoryToggle from '@/components/ui/ActiveHistoryToggle'
import FeatureBanner from '@/components/common/FeatureBanner'
import RecommendationStatsCard from '@/components/ui/RecommendationStatsCard'
import IntroVideoModal from '@/components/signale/IntroVideoModal'
import TradingDisclaimerModal from '@/components/signale/TradingDisclaimerModal'
import { useFeatureAccess } from '@/hooks/useFeatureAccess'
import { APIRoutes } from '@/services/api.routes'
import type { RecommendationStats } from '@/models'

export default function KernstrategiePage() {
  const [showHistory, setShowHistory] = useState(false)
  const [stats, setStats] = useState<RecommendationStats | null>(null)
  const [statsLoading, setStatsLoading] = useState(true)
  const { hasFeature } = useFeatureAccess()
  const hasAccess = hasFeature('coreRecommendations')

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const overview = await APIRoutes.getStatistics()
        const free = overview.statsFree.coreRecommendationStats
        const normal = overview.statsNormal.coreRecommendationStats
        setStats({
          total: free.total + normal.total,
          open: free.open + normal.open,
          success: free.success + normal.success,
          failed: free.failed + normal.failed
        })
      } catch {
        // Silently fail - stats are optional
      } finally {
        setStatsLoading(false)
      }
    }
    fetchStats()
  }, [])

  return (
    <>
      <TradingDisclaimerModal />
      <IntroVideoModal type="CORE" />
      <div className="mb-8">
        <div className="flex justify-between items-start">
          <div>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
              Kern&shy;strategie
            </h1>
            <p className="mt-2 text-gray-600 dark:text-gray-400">
              Grundlegende Trading-Strategie
            </p>
          </div>
          <ActiveHistoryToggle showHistory={showHistory} onToggle={setShowHistory} />
        </div>
      </div>

      <RecommendationStatsCard stats={stats} loading={statsLoading} type="core" />

      {!hasAccess && <FeatureBanner featureName="coreRecommendations" />}

      <TradingRecommendationsList
        filterType="CORE"
        showHistory={showHistory}
        hasAccess={hasAccess}
        activeTitle="Aktive Kernstrategie-Tradingideen"
        historyTitle="Historische Kernstrategie-Tradingideen"
      />
    </>
  )
}
